var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components
import VIcon from '../VIcon';
import VBtn from '../VBtn/VBtn';
// Types
import Vue from 'vue';
/* @vue/component */
export default Vue.extend({
    name: 'v-app-bar-nav-icon',
    functional: true,
    render: function render(h, _ref) {
        var slots = _ref.slots,
            listeners = _ref.listeners,
            props = _ref.props,
            data = _ref.data;

        var d = Object.assign(data, {
            staticClass: ('v-app-bar__nav-icon ' + (data.staticClass || '')).trim(),
            props: _extends({}, props, {
                icon: true
            }),
            on: listeners
        });
        var defaultSlot = slots().default;
        return h(VBtn, d, defaultSlot || [h(VIcon, '$vuetify.icons.menu')]);
    }
});
//# sourceMappingURL=VAppBarNavIcon.js.map